import { Discount as IDiscount } from "utils/interfaces"

export class Discount implements IDiscount {
    id = 0
    percent = 0
    flat = 0
    max_amount = 0
    price_limit: number | null = null
    is_unlimited_by_session_count = false
    type!: IDiscount["type"]

    constructor(init: IDiscount) {
        Object.assign(this, init)
    }

    toString(): string {
        const parts = []

        if (this.percent) {
            parts.push(`${this.percent * 100}%`)
        }

        if (this.flat) {
            if (this.percent) {
                parts.push("+")
            }
            parts.push(`${this.flat} ₽`)
        }

        if (this.max_amount) {
            parts.push(`(до ${this.max_amount} ₽)`)
        }

        return parts.join(" ")
    }

    apply(price: number): number {
        if (this.price_limit !== null && price > this.price_limit) {
            return price
        }

        const discountValue = Math.min(
            price * this.percent + this.flat,
            this.max_amount || Infinity
        )

        return Math.max(Math.floor(price - discountValue), 0)
    }
}

export function applyDiscount(discount: IDiscount, price: number) {
    // todo вместо этого нужно просто с бэка загружать сразу цену с применённой скидкой
    return new Discount(discount).apply(price)
}
